/**
 * Gifts page: delivery dates (cutoff + working days) and dog/cat wording from the Dogs | Cats toggle.
 */
class HomGifts extends HTMLElement {
  connectedCallback() {
    this.#dates();
    this.#pet();
    document.addEventListener('hom:pet-change', this.#pet);
  }

  disconnectedCallback() {
    document.removeEventListener('hom:pet-change', this.#pet);
  }

  #pet = () => {
    const pet = document.documentElement.dataset.pet === 'cat' ? 'cat' : 'dog';
    for (const el of this.querySelectorAll('[data-pet-word]')) el.textContent = pet;
  };

  #dates() {
    const fmt = (d) => d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
    const addW = (d, n) => {
      d = new Date(d);
      while (n > 0) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() % 6) n--;
      }
      return d;
    };
    const now = new Date();
    const cutoff = Number(this.dataset.cutoffHour) || 12;
    const start = now.getHours() >= cutoff ? addW(now, 1) : now;
    const f = Number(this.dataset.deliveryFrom) || 6;
    const t = Number(this.dataset.deliveryTo) || 8;
    for (const el of this.querySelectorAll('[data-d2]')) el.textContent = `${fmt(addW(start, f))}–${fmt(addW(start, t))}`;
  }
}

if (!customElements.get('hom-gifts')) customElements.define('hom-gifts', HomGifts);
